import { FiHelpCircle } from 'react-icons/fi';
import { useSiteConfig } from '../context/SiteConfigContext';

function SponsoredSection({ className = '', compact = false, showLabel = true }) {
  const { config } = useSiteConfig();
  const imageUrl = config?.sponsored?.image_url;
  const linkUrl = config?.sponsored?.link_url;

  if (!imageUrl) {
    return null;
  }

  const media = (
    <img
      src={imageUrl}
      alt="Sponsored"
      className={`sponsored-section__img${compact ? ' sponsored-section__img--compact' : ''}`}
    />
  );

  return (
    <aside className={`sponsored-section${compact ? ' sponsored-section--compact' : ''} ${className}`.trim()}>
      {showLabel ? (
        <div className="sponsored-section__label">
          <FiHelpCircle aria-hidden />
          <span>Sponsored</span>
        </div>
      ) : null}
      <div className="sponsored-section__body">
        {linkUrl ? (
          <a href={linkUrl} target="_blank" rel="noreferrer sponsored noopener" className="sponsored-section__link">
            {media}
          </a>
        ) : (
          media
        )}
      </div>
    </aside>
  );
}

export default SponsoredSection;
